import { isMobile, ProductUsps } from '@kizi/comparator-components';
import { Div, P } from '@kizi/core-components';
import React from 'react';

export const ProductCardMainSection = ({
  data,
  productUspsContent,
  setCurrentModalTab,
  inTopThree = false,
}) => {
  const subscriptionTitle = data?.subscriptionName;

  const underlineStyles =
    isMobile() || inTopThree
      ? { fontSize: '16px', lineHeight: '24px' }
      : {
          textDecoration: 'underline',
          textDecorationColor: 'rgba(0, 77, 245, 0.3)',
          textDecorationStyle: 'dashed',
          textUnderlineOffset: '5px',
          fontSize: '14px',
          lineHeight: '21px',
        };

  const customProductUspsContent = {
    ...productUspsContent,
    onItemClick: isMobile()
      ? () => setCurrentModalTab(0)
      : () => productUspsContent.onItemClick(),
  };

  return (
    <Div flex={1} display={'flex'} flexDirection={'column'} gridGap={'8px'}>
      {subscriptionTitle && (
        <P variant="bodyV2" fontWeight={700}>
          {subscriptionTitle}
        </P>
      )}

      <ProductUsps
        {...customProductUspsContent}
        css={underlineStyles}
        containerProps={{
          'svg': {
            width: '24px',
            height: '24px !important',
          },
        }}
      />
    </Div>
  );
};
